module.exports = __webpack_public_path__ + "static/media/g-4.14e93edf.jpg";